export default "__VITE_ASSET__6ab79412__"